/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from 'react';
import ELEMENT from 'common/element';
import { Host } from 'common/graphqlTypes';
import { VariableSizeList } from 'react-window';
import { useTable } from 'react-table';
import LogOverviewSourcesRow from './LogOverviewSourcesRow';
import './Sources.scss';

type SourcesListProps = {
  sources: Array<Host>;
};

const sourceListColumns = [
  {
    Header: 'Source',
    accessor: 'name',
    testId: ELEMENT.overviewSourcesHeaderSource,
  },
  {
    Header: 'Logs',
    accessor: 'logFiles',
    testId: ELEMENT.overviewSourcesHeaderLogfile,
  },
  {
    Header: 'Dashboards',
    accessor: 'dashboards',
    testId: ELEMENT.overviewSourcesHeaderDashboards,
  },
];

const SOURCE_LIST_WINDOW_HEIGHT = 800;
const SOURCE_LIST_ITEM_SIZE = 150;

/**
 * This component creates a list of the the sources on the Log Overview page.
 * @param {*} param
 */

const SourcesList = ({ sources }: SourcesListProps): JSX.Element => {
  const { getTableProps, headers, rows, prepareRow } = useTable({
    columns: sourceListColumns as any,
    data: sources,
  });

  const headerSection = headers.map((column: any) => (
    <div
      {...column.getHeaderProps()}
      className={`SourcesTable__ColumnHeader SourcesTable__ColumnHeader--${column.Header}`}
      data-test-id={column.testId}
    >
      {column.render('Header')}
    </div>
  ));

  const renderRow = useCallback(
    ({ index, style }) => {
      const row = rows[index];
      prepareRow(row);
      const host = row.original as Host;
      return <LogOverviewSourcesRow style={style} source={host} index={index} key={host.name} />;
    },
    [rows, prepareRow],
  );

  const noResultsMessage =
    rows.length === 0 ? <div className="SourcesTable__NoResults">There are no results to show.</div> : null;

  return (
    <div {...getTableProps()}>
      <div className="SourcesTable__HeaderRow">{headerSection}</div>

      {noResultsMessage}

      <VariableSizeList
        height={SOURCE_LIST_WINDOW_HEIGHT}
        className="VirtualisedTable__Body--ScrollArea"
        itemCount={rows.length}
        itemSize={(): number => SOURCE_LIST_ITEM_SIZE}
        width="100%"
      >
        {renderRow}
      </VariableSizeList>
    </div>
  );
};

export default SourcesList;
